import { Currency } from '@synergy/models';

export const getCurrencySymbol = (currency: string | Currency, locale: string): string => {
    const formattedCurrency = Intl.NumberFormat(locale.replace('_', '-'), {
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
    }).format(0);

    const match = /(?![\d\s.,'])[^\d\s.,']*/.exec(formattedCurrency);
    if (match) {
        return match[0];
    }
    return '';
};
